export enum PostHogEventEnum {
  Pageview = '$pageview',
  AiPreviewNewsClose = 'ai_preview_news_close',

  // Auth
  LoginCompleted = 'login_completed',
  SignupCompleted = 'signup_completed',
  OAuthCompleted = 'oauth_completed',

  // Knowledge Base
  ArticleCreated = 'article_created',
  ArticleUpdated = 'article_updated',
  ArticleDeleted = 'article_deleted',

  // Actions
  ActionCreated = 'action_created',
  ActionUpdated = 'action_updated',
  ActionTested = 'action_tested',

  // Conversations
  ConversationResolved = 'conversation_resolved',
  ConversationReopened = 'conversation_reopened',
  HumanTakeoverInitiated = 'human_takeover_initiated',

  // Onboarding
  OnboardingStepCompleted = 'onboarding_step_completed',

  // Subscription
  SubscriptionCheckoutStarted = 'subscription_checkout_started',
  PlanUpgraded = 'plan_upgraded',

  // Why AI Said That
  WhyAiSaidThatOpened = 'why_ai_said_that_opened',
}

export enum PostHogFeatureFlagEnum {
  AiPreviewNews = 'ai_preview_news',
  SignupBackgroundTest = 'signup_background_test',
}

export enum SignupBackgroundVariant {
  Control = 'control',
  Blur = 'blur',
}

export enum PostHogUserPropertyEnum {
  AiPreviewNews = 'ai_preview_news',
}
